<header class="section-header">
  <h2>نقشه حرارتی فعالیت روزانه</h2>
  <span>شدت حرکت<span *ngIf="dayCount"> در {{ dayCount }} روز</span></span>
</header>
<app-chart [context]="chartContext"></app-chart>
<div class="legend">
  <span class="intensity-scale" aria-label="مقیاس ساعات حرکت">
    <bdi>0</bdi><i class="gradient" aria-hidden="true"></i>
    <bdi>{{ maxHours === null ? '—' : (maxHours | number:'1.1-1':'en-US') }}</bdi>
    <span>ساعت حرکت</span>
  </span>
  <span class="status-legend">
    <span class="missing-label"><i class="missing" aria-hidden="true"></i>فاقد داده</span>
    <span class="missing-label"><b class="warning-symbol" aria-hidden="true">!</b>نیازمند بررسی</span>
  </span>
</div>
<p class="chart-note">هر خانه یک روز است؛ مقدار دقیق با مکث یا لمس نمایش داده می‌شود.</p>
<details class="daily-details" *ngIf="days.length">
  <summary>جزئیات وضعیت روزها</summary>
  <ul tabindex="0" aria-label="وضعیت روزهای ثبت‌شده">
    <li *ngFor="let day of days">
      <bdi class="day-date">{{ day.name }}</bdi>
      <span>ساعت حرکت: <bdi>{{ day.value === null ? 'فاقد داده' : (day.value | number:'1.2-2':'en-US') }}</bdi></span>
      <span *ngFor="let detail of day.details">{{ detail }}</span>
    </li>
  </ul>
</details>
